import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function SearchIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 50 50">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.086 9.8C15.748 9.8 9.8 15.752 9.8 23.1c0 7.348 5.95 13.301 13.286 13.301 3.58 0 6.83-1.418 9.219-3.724a1.904 1.904 0 0 1 .345-.345 13.263 13.263 0 0 0 3.721-9.231c0-7.349-5.95-13.3-13.285-13.3Zm13.349 23.975A17.038 17.038 0 0 0 40.172 23.1c0-9.443-7.65-17.1-17.086-17.1C13.646 6 6 13.657 6 23.1c0 9.443 7.648 17.102 17.086 17.102 4.033 0 7.74-1.4 10.663-3.739l6.973 6.98a1.9 1.9 0 0 0 2.688-2.686l-6.975-6.982Z"
            />
        </SvgIcon>
    );
}
